import(/* webpackMode: "eager", webpackExports: ["SimulationPageContent"] */ "/vercel/path0/components/simulations/SimulationPageContent.tsx");
